// @angular/core
import { NgModule } from '@angular/core';

// @angular/common
import { CommonModule } from '@angular/common';

// @angular/common/http
import { HttpClientModule } from '@angular/common/http';

// Components
import { FangMultiTabsComponent } from './fang-multi-tabs.component';
import { FangTabComponent } from './fang-tab.component';

@NgModule({
	declarations: [
		FangMultiTabsComponent,
		FangTabComponent
	],
	imports: [
		CommonModule,
		HttpClientModule
	],
	exports: [
		FangMultiTabsComponent,
		FangTabComponent
	],
	providers: []
})
export class FangMultiTabsModule {}
